/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ReactNode } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { Stack, Text } from '@atlaskit/primitives/compiled';

const styles = cssMap({
	section: {
		width: '100%',
		minWidth: '0',
	},
});

export const PreviewSection = ({
	title,
	children,
}: {
	title: string;
	children: ReactNode;
}): JSX.Element => (
	<Stack space="space.100" xcss={styles.section}>
		<Text weight="semibold">{title}</Text>
		{children}
	</Stack>
);
